export default __webpack_public_path__ + "static/media/GillSansLight.7c646be8.otf";